module.exports = __webpack_public_path__ + "static/canvasintro-85efbfa042a32e90cb2f410bfb38f34e.mp4";